import './ui/styles.css';
import './ui/theme-new.css';
import { loadLang } from '@/i18n';
import { applyArtStyleClass } from '@/ui/artStyle';
import { prefetchManifest } from '@/assets/manifestPrefetch';

// v1.4：先決定畫面風格（新版／經典版），介面 CSS 用 <html class="style-new"> 切換
applyArtStyleClass();
// v1.4.1 素材清單先開始抓（和下載遊戲本體同時進行）
void prefetchManifest();
// v0.7：先載入語言（英文版才下載英文字典），再載入遊戲本體
loadLang().then(() => import('./app')).then(m => m.boot());
